const hasMessage = error => typeof error === 'object' && typeof error.message === 'string';
const getUnknownErrorMessage = error => {
  if (hasMessage(error)) return error.message;
  return 'An unknown error occurred.';
};
const errorSuffix = `Please try refreshing the page, or contact
  team@caresend.com if you continue to encounter issues.`;
const errorSuffixNurse = `Please try refreshing the page, or get in touch
  by choosing “Help” from the menu if you continue to encounter issues.`;

export { errorSuffix, errorSuffixNurse, getUnknownErrorMessage, hasMessage };
